import state from './DesignState.js'
import mutations from './DesignMutations.js'
import actions from './DesignActions.js'
import getters from './DesignGetters.js'

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
